<template>
  <div class="container">
    <div class="container-inner">
      <div style="display: flex;margin-top: 30px;height: 40px;">
        <div style="color: #1F2329;font-weight: 500;font-size: 32px;margin-right: 20px;line-height: 40px;">标书查重</div>
        <div v-if="serviceInfo.remainNum" style="font-weight: 400;font-size: 14px;color: #1F2329;margin-top: 16px;">
          您的账号还有 <span style="color:#FD9774 ">{{ serviceInfo.remainNum }}</span> 次检查，请在
          <span style="color:#FD9774 ">{{ serviceInfo.serviceEndTime|parseTime }}</span> 前使用
        </div>
        <div v-else style="font-weight: 400;font-size: 14px;color: #1A66FF;margin-top: 16px;">{{ srcSymbol=='biaoshitong'?'当前支持2份文件免费检查，如需3-5份可先查后付费！':'您当前还没有检查次数，可以先检查后付费！'}}</div>
      </div>
      <div style="display: flex;margin-top: 15px;">
        <step :current="1"></step>
        <div style="flex: 1;"></div>
        <div style="line-height: 40px;color: #1F2329;font-weight: 400;font-size: 16px;cursor:pointer;" @click="goHistory"   v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_history'],actionCode:'xsd_all_history'}">历史记录 <i
            class="el-icon-arrow-right"></i></div>
      </div>
      <div class="rules_box">
        <div class="box_title">第一步：设置检查规则</div>
        <div style="margin-top: 10px;">
<!--          <el-form label-width="100px">-->
<!--            <el-form-item label="选择文件格式" prop="taskName">-->
<!--              <el-radio-group v-model="fileType" @change="fileTypeChange">-->
<!--                <el-radio :label="1">pdf</el-radio>-->
<!--                <el-radio :label="2">word</el-radio>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
<!--          </el-form>-->
        </div>
        <div>
          <!--  文件类型为word   -->
          <el-form v-if="fileType == 2" ref="wordForm" :model="wordForm" :rules="wordRules" label-width="100px">
            <el-form-item label="检查名称" prop="taskName">
              <el-input v-model="wordForm.taskName" placeholder="请输入检查名称" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="是否过滤招标" prop="bid_sim_flag">
              <el-radio-group v-model="wordForm.bid_sim_flag" @change="isZbChange">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
              <div v-if="wordForm.bid_sim_flag == 1">
                <el-upload
                    v-show="!zbList.length"
                    ref="zb_upload"
                    :auto-upload="false"
                    :file-list="zbList"
                    :limit="1"
                    :multiple="false"
                    :on-change="zb_change"
                    :on-remove="zb_remove"
                    :show-file-list="false"
                    accept=".docx"
                    action=""
                >
                  <div
                      class="up_box" style="margin-top: 5px;">
                    <img alt="" src="@/assets/image/up.png">
                    <div style="font-size: 12px;color: #888;line-height: 20px;">导入招标文件</div>
                    <div style="font-size: 12px;color: #888;line-height: 20px;">仅支持单文件上传</div>
                  </div>
                </el-upload>
                <div v-show="zbList.length" style="margin-top: 5px;">
                  <div v-for="(item, idx) in zbList" :key="idx" class="up_box">
                    <i
                        class="el-icon-remove-outline"
                        style="position: absolute;right: 10px;top:10px; cursor: pointer"
                        @click="del_zb_file(item)"
                    ></i>
                    <img alt="" src="@/assets/image/word.png">
                    <el-tooltip :content="item.name" effect="dark" placement="top-start">
                      <div class="fileName">{{ item.name }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="检查内容" prop="checkContent">
              <el-checkbox-group v-model="wordForm.checkContent">
                <el-checkbox label="para_sim_flag">文本段落</el-checkbox>
                <el-checkbox label="table_sim_flag">表格</el-checkbox>
                <el-checkbox label="img_sim_flag">图片</el-checkbox>
                <el-checkbox label="author_sim_flag">作者雷同</el-checkbox>
                <el-checkbox label="phone_sim_flag">电话雷同</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <!--文件类型为pdf          -->
          <el-form v-if="fileType == 1" ref="pdfForm" :model="pdfForm" :rules="pdfRules" label-width="100px">
            <el-form-item label="检查名称" prop="project_name">
              <el-input v-model="pdfForm.project_name" placeholder="请输入检查名称" :disabled="true" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="是否过滤招标" prop="bid_sim_flag">
              <el-radio-group v-model="pdfForm.bid_sim_flag" @change="isZbChange" :disabled="true">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
              <div v-if="pdfForm.bid_sim_flag == 1">
                <el-upload
                    v-show="!zbList.length"
                    ref="zb_upload"
                    :auto-upload="false"
                    :file-list="zbList"
                    :limit="1"
                    :multiple="false"
                    :on-change="zb_change"
                    :on-remove="zb_remove"
                    :show-file-list="false"
                    accept=".pdf"
                    action=""
                >
                  <div
                      class="up_box" style="margin-top: 5px;">
                    <img alt="" src="@/assets/image/up.png">
                    <div style="font-size: 12px;color: #888;line-height: 20px;">导入招标文件</div>
                    <div style="font-size: 12px;color: #888;line-height: 20px;">仅支持单文件上传</div>
                  </div>
                </el-upload>
                <div v-show="zbList.length" style="margin-top: 5px;">
                  <div v-for="(item, idx) in zbList" :key="idx" class="up_box">
                    <!-- <i
                        class="el-icon-remove-outline"
                        style="position: absolute;right: 10px;top:10px; cursor: pointer"
                        @click="del_zb_file(item)"
                    ></i> -->
                    <img alt="" src="@/assets/image/pdf.png">
                    <el-tooltip :content="item.name" effect="dark" placement="top-start">
                      <div class="fileName">{{ item.name }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="检查内容" prop="checkContent">
              <el-checkbox-group v-model="pdfForm.checkContent" :disabled="true">
                <el-checkbox label="text">文本&表格</el-checkbox>
                <el-checkbox label="check_author">检查作者</el-checkbox>
<!--                <el-checkbox label="picture_sim">图片相似度</el-checkbox>-->
<!--                <el-checkbox label="error_write">错别字检查</el-checkbox>-->
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="file_box">
        <div style="display: flex;">
          <div class="box_title" style="margin-right: 10px;">第二步：导入对比文件</div>
          <div style="flex: 1;">
            <div v-if="actionType == 2" style="color: #2D53ED;font-size: 14px;margin-top: 3px;">
              {{ srcSymbol=='biaoshitong'?'提示：支持免费检查2个单位，目前最多支持选择5个单位，每个单位最多5个文件，如果需要更多单位，请联系我们。':'提示：目前最多支持选择5个单位，每个单位最多5个文件，如果需要更多单位，请联系我们。'}}
              
            </div>
            <div v-if="actionType ==1" style="color: #2D53ED;font-size: 14px;margin-top: 3px;">
              {{ srcSymbol=='biaoshitong'?'提示：支持免费检查2份文件，目前版本最多支持5份文件检查，如需更多份数，请联系我们。':'提示：目前最多支持选择5个单位（每个文件默认1个单位），如果需要更多单位，请联系我们。'}}
            </div>
          </div>
          <div v-if="actionType == 1 && srcSymbol!='biaoshitong'" style="color: #1F2329;font-weight: 600;font-size: 16px;cursor: pointer;"
               @click="changeActionType(2)">
            <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
            切换【多个子文件】上传模式
          </div>
          <div v-if="actionType == 2 && srcSymbol!='biaoshitong'" style="color: #1F2329;font-weight: 600;font-size: 16px;cursor: pointer;"
               @click="changeActionType(1)">
            <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
            切换【单个子文件】上传模式
          </div>
        </div>
        <div v-if="actionType == 1" style="display: flex;flex-flow: wrap;">
          <div v-for="(item, idx) in single_tbList" :key="idx" class="up_box"
               style="margin-top:10px;margin-right: 8px;">
            <!-- <i
                class="el-icon-remove-outline"
                style="position: absolute;right: 10px;top:10px; cursor: pointer"
                @click="del_tb_file(item)"
            ></i> -->
            <img v-if="fileType == 2" alt="" src="@/assets/image/word.png">
            <img v-if="fileType == 1" alt="" src="@/assets/image/pdf.png">
            <el-tooltip :content="item.name" effect="dark" placement="top-start">
              <div class="fileName">{{ item.name }}</div>
            </el-tooltip>
          </div>
          <!-- <el-upload
              ref="tb_upload"
              :accept="fileExt"
              :auto-upload="false"
              :file-list="single_tbList"
              :multiple="true"
              :on-change="tb_change"
              :on-remove="tb_remove"
              :show-file-list="false"
              action=""
          >
            <div
                class="up_box" style="margin-top: 10px;margin-right: 8px;">
              <img alt="" src="@/assets/image/up.png">
              <div style="font-size: 12px;color: #888;line-height: 20px;">导入投文件</div>
              <div style="font-size: 12px;color: #888;line-height: 20px;">支持多文件上传</div>
            </div>
          </el-upload> -->
        </div>
        <div v-if="actionType == 2" style="display: flex;flex-flow: wrap;">
          <mutilFile v-for="(item, idx) in mutil_tbList" :key="idx"
                     :alltb="tbList"
                     :allzb="zbList"
                     :ext="fileExt"
                     :fileData="item"
                     @change="fileChange"
                     @delCompany="delCompany">

          </mutilFile>
          <div class="mutilFileBox1" style="margin-top: 10px;cursor: pointer;" @click="addCompany">
            <img alt="" src="@/assets/image/up.png">
            <div style="font-size: 12px;color: #888;line-height: 20px;">新增投标单位</div>
          </div>
        </div>
      </div>

      <div class="startBtn" @click="startBtn" v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_start'],actionCode:'xsd_all_start'}">开始检查</div>
    </div>
  </div>
</template>

<script>
import {getServiceNum, startTask as wordStart,} from "@/api/word";
import {pdf_pre_check, getDemoProjectId} from "@/api/pdf";
import {mapMutations, mapState} from "vuex";
import moment from "moment";
import step from "@/components/step";
import mutilFile from "@/components/mutilFile";

export default {
  name: "indexPage",
  components: {
    step,
    mutilFile
  },
  data() {
    return {
      fileType: 1,// 1 pdf  2 word
      actionType: 1,//1 投标单文件  2投标多文件
      wordForm: {
        taskName: "",
        checkContent: [],
        bid_sim_flag: 0
      },
      wordRules: {
        taskName: [
          {required: true, message: '请输入任务名称', trigger: 'blur'},
        ],
        checkContent: [
          {type: 'array', required: true, message: '请至少选择一个检查内容', trigger: 'change'}
        ],
      },
      pdfForm: {
        project_name: "山西晋能源附属项目",
        checkContent: ["text","check_author"],
        bid_sim_flag: 1
      },
      pdfRules: {
        project_name: [
          {required: true, message: '请输入任务名称', trigger: 'blur'},
        ],
        checkContent: [
          {type: 'array', required: true, message: '请至少选择一个检查内容', trigger: 'change'}
        ],
      },
      //招标文件
      zbList: [{name: '山西晋能源附属项目招标文件.pdf'}],
      //多投标文件信息
      mutil_tbList: [],
      //单文件投标信息
      single_tbList: [{name:"1建设工程施组设计事例.pdf"},{name:"2建设通风系统事例工程.pdf"}],
      // 上传任务列表
      taskList: [],
      //上传结果
      taskRes: [],
      load: null
    }
  },
  async mounted() {
    await this.getServiceNum();
  },
  methods: {
    /**
     * 查询服务次数
     */
    async getServiceNum() {
      let res = await getServiceNum()
      let data = res.data;
      if (data.login_data?.is_login) {
        // let temp = this.$_.filter(data.data, (item) => {
        //   return item.vipServiceName === '标书对比'
        // })
        let temp = data.data;
        this.setServiceInfo(temp[0] ? temp[0] : {remainNum: 0})
      } else {
        this.changeLogin(false)
      }
    },
    /**
     * 招标文件列表变动
     */
    zb_change(file, fileList) {
      //检查文件格式
      if (!this.$util.checkFileExt(file, this.extList)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["zb_upload"].handleRemove(file);
        this.zbList = fileList;
        return;
      }
      //检查文件数量
      if (!this.$util.checkAllFileNums(fileList, 1)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["zb_upload"].handleRemove(file);
        this.zbList = fileList;
        return;
      }
      //检查文件大小
      if (!this.$util.checkAllFileSize(fileList, 1000)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["zb_upload"].handleRemove(file);
        this.zbList = fileList;
        return;
      }
      this.zbList = fileList;
      // const self = this;
      // const fileReader = new FileReader();
      // const dataFile = file.raw;
      // fileReader.readAsArrayBuffer(dataFile);
      // fileReader.onload = function (e) {
      //   const hash = self.$md5.create();
      //   hash.update(e.target.result);
      //   file["contentMd5"] = hash.base64();
      //   self.zbList = fileList;
      // };
    },
    /**
     * 招标文件删除
     */
    zb_remove(file, fileList) {
      this.zbList = fileList;
    },
    /**
     * 招标文件删除动作
     */
    del_zb_file(item) {
      this.$refs["zb_upload"].handleRemove(item);
    },
    /**
     * 切换文件类型
     */
    fileTypeChange() {
      this.zbList = [];
      this.mutil_tbList = [];

      this.single_tbList = [];
    },
    /**
     * 是否过滤招标文件改变
     */
    isZbChange(val) {
      if (val == 0) {
        this.zbList = [];
      }
    },
    /**
     * 切换文件上传方式
     */
    changeActionType(type) {
      //切换上传方式的时候  删除原来的上传的文件
      if (type == 1) {
        this.mutil_tbList = [];

      } else if (type == 2) {
        this.single_tbList = [];
      }
      this.actionType = type;
    },
    /**
     * 投标文件列表变动
     */
    tb_change(file, fileList) {
      //检查文件格式
      if (!this.$util.checkFileExt(file, this.extList)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["tb_upload"].handleRemove(file);
        this.single_tbList = fileList;
        return;
      }
      //检查文件数量
      if (!this.$util.checkAllFileNums(fileList, 10)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["tb_upload"].handleRemove(file);
        this.single_tbList = fileList;
        return;
      }
      //检查文件大小
      if (!this.$util.checkAllFileSize(fileList, 1000)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["tb_upload"].handleRemove(file);
        this.single_tbList = fileList;
        return;
      }
      // const self = this;
      // const fileReader = new FileReader();
      // const dataFile = file.raw;
      this.single_tbList = fileList;
      // fileReader.readAsArrayBuffer(dataFile);
      // fileReader.onload = function (e) {
      //   const hash = self.$md5.create();
      //   hash.update(e.target.result);
      //   file["contentMd5"] = hash.base64();
      //   console.log(self.single_tbList)
      //   // self.single_tbList = fileList;
      // };
    },
    /**
     * 投标文件删除
     */
    tb_remove(file, fileList) {
      this.single_tbList = fileList;
    },

    /**
     * 投标文件删除动作
     */
    del_tb_file(item) {
      this.$refs["tb_upload"].handleRemove(item);
    },
    /**
     * 多投标文件列表变动
     */
    fileChange(fileList, idx) {
      this.$_.each(this.mutil_tbList, (item) => {
        if (item.idx === idx) {
          item.fileList = fileList;
        }
      });
    },
    /**
     * 添加投标单位
     */
    addCompany() {
      if (this.mutil_tbList.length >= 10) {
        this.$util.warning("最多支持10家单位！");

      } else {
        this.mutil_tbList.push({
          idx: this.$uuid(),
          name: `投标单位${this.mutil_tbList.length + 1}`,
          fileList: [],
        });
      }
    },
    /**
     * 删除投标公司
     */
    delCompany(idx) {
      this.mutil_tbList = this.$_.reject(this.mutil_tbList, (item) => {
        return item.idx === idx;
      });
      this.$_.each(this.mutil_tbList, (item, index) => {
        item.name = `投标单位${index + 1}`;
      });
    },

    /**
     * 开始检查按钮
     */
    async startBtn() {
      const res = await getDemoProjectId()
      this.set_signName_pdf(res.data.sign_name);
      this.set_projectId_pdf(res.data.project)
      if (this.fileType == 1) {
        this.pdf_startBtn();
      } else {
        this.word_startBtn();
      }
    },

    /**
     * word 开始检查
     */
    word_startBtn() {
      this.$router.push("/pdfProcessExample");
      // try {
      //   this.$refs['wordForm'].validate(async (valid) => {
      //     if (valid) {
      //       if (this.isLogin) {
      //         if (this.precheck()) {
      //           this.load = this.$util.load_show();
      //           if (this.hasZb) {
      //             this.zb_upload();
      //           }
      //           this.tb_upload();
      //           this.taskRes = await Promise.all(this.taskList);
      //           let flg = this.$_.every(this.taskRes, (item) => {
      //             return item ? true : false
      //           })
      //           if (flg) {
      //             await this.startTask();
      //           }
      //         }
      //       } else {
      //         let data = {
      //           source: "similarity",
      //           info: {
      //             actionType: 1, //  1需要登录
      //             savePath: location.herf,
      //           },
      //         };
      //         window.parent.postMessage(JSON.stringify(data), "*");
      //       }
      //     }
      //   })
      // } catch (err) {
      //   console.log(err)
      // }
    },
    /**
     * pdf 开始检查
     */
    async pdf_startBtn() {
      this.$router.push("/pdfProcessExample");
      // try {
      //   this.$refs["pdfForm"].validate(async (valid) => {
      //     if (valid) {
      //       if (this.isLogin) {
      //         if (this.precheck()) {
      //           this.load = this.$util.load_show();
      //           if (this.hasZb) {
      //             this.zb_upload()
      //           }
      //           this.tb_upload();
      //           this.taskRes = await Promise.all(this.taskList);
      //           let flg = this.$_.every(this.taskRes, (item) => {
      //             return item ? true : false
      //           });
      //           if (flg) {
      //             await this.startTask();
      //           }
      //         }
      //       } else {
      //         let data = {
      //           source: "similarity",
      //           info: {
      //             actionType: 1, //  1需要登录
      //             savePath: location.herf,
      //           },
      //         };
      //         window.parent.postMessage(JSON.stringify(data), "*");
      //       }
      //     }
      //   })
      // } catch (err) {
      //   console.log(err)
      // }
    },

    startTask() {
      if (this.fileType == 1) {
        this.pdf_startTask();
      } else {
        this.word_startTask();
      }
    },
    /**
     * word  开始任务
     */
    async word_startTask() {
      let jsonData = this.word_assembleParams();
      let res = await wordStart(jsonData);
      this.set_signName_word(res.data.sign_name);
      this.set_checkName_word(this.wordForm.taskName);
      this.load && this.load.close();
      await this.$router.push("/wordProcess");
    },
    /**
     * word  组装参数
     */
    word_assembleParams() {
      let checkContent = this.wordForm.checkContent;
      let flag_setting = {};
      this.$_.each(checkContent, (k) => {
        flag_setting[k] = 1;
      })
      let zb = this.$_.filter(this.taskRes, (item) => {
        return item.filetype == "zb"
      })
      let tb = this.$_.filter(this.taskRes, (item) => {
        return item.filetype == "tb"
      })
      tb = this.$_.groupBy(tb, 'unitName')

      let bid_doc = this.$_.map(zb, (item) => {
        return {
          uid: item.uid,
          path: item.path,
          file_name: item.file_name
        }
      })
      let docs = this.$_.map(tb, (item, key) => {
        return {
          tender_name: key,
          path: this.$_.map(item, (_item) => {
            return {
              uid: _item.uid,
              path: _item.path,
              file_name: _item.file_name
            }
          })
        }
      })
      let jsonData = {
        check_name: this.wordForm.taskName,
        project: this.projectId,
        settings: this.settings_word,
        flag_setting: flag_setting,
        bid_sim_flag: this.wordForm.bid_sim_flag,
        bid_doc: bid_doc,
        docs: docs
      }
      return jsonData
    },

    /**
     * pdf 开始任务
     */
    async pdf_startTask() {
      let jsonData = this.pdf_assembleParams();
      let res = await pdf_pre_check(jsonData);
      this.set_signName_pdf(res.data);
      this.set_checkName_pdf(this.pdfForm.project_name);
      this.load && this.load.close();
      await this.$router.push("/pdfProcess");
    },

    /**
     * pdf 参数组装
     */
    pdf_assembleParams() {
      let checkContent = this.pdfForm.checkContent;
      let flag_setting = {};
      this.$_.each(checkContent, (k) => {
        flag_setting[k] = "1";
      });
      let zb = this.$_.filter(this.taskRes, (item) => {
        return item.filetype == "zb"
      })
      let tb = this.$_.filter(this.taskRes, (item) => {
        return item.filetype == "tb"
      })
      let bid_doc = this.$_.map(zb, (item) => {
        return {
          file_id: item.fileId,
          url: item.path,
          alias: item.file_name
        }
      })
      tb = this.$_.map(tb, (item) => {
        return {
          file_id: item.fileId,
          url: item.path,
          alias: item.file_name,
          unitName: item.unitName
        }
      })
      let docs = tb = this.$_.groupBy(tb, 'unitName');
      let jsonData = {
        project_name: this.pdfForm.project_name,
        project: this.projectId,
        settings: this.settings_pdf,
        bid_doc: bid_doc,
        docs: docs,
        ...flag_setting
      };

      return jsonData;
    },


    /**
     * 招标文件上传
     */
    zb_upload() {
      this.$_.each(this.zbList, (item) => {
        this.taskList.push(this.$util.upFile(item, "bswjjc_sc", "zb", this.projectId));
      });
    },

    /**
     * 投标文件上传
     */
    tb_upload() {
      this.$_.each(this.tbList, (item) => {
        this.taskList.push(this.$util.upFile(item, "bswjjc_sc", "tb", this.projectId));
      });
    },
    /**
     * 预检查
     */
    precheck() {
      if (this.hasZb) {
        if (this.zbList.length == 0) {
          this.$util.warning("您还未选择招标文件")
          return false
        }
      }
      if (this.tbList.length == 0) {
        this.$util.warning("您还未选择投标文件")
        return false
      }
      if (this.actionType == 1) {
        if (this.tbList.length < 2) {
          this.$util.warning("请添加最少两个单位进行操作")
          return false
        }
      }
      if (this.actionType == 2) {
        if (this.mutil_tbList.length < 2) {
          this.$util.warning("请添加最少两个单位进行操作")
          return false
        }
        for (let i = 0; i < this.mutil_tbList.length; i++) {
          let item = this.mutil_tbList[i]
          if (item.fileList.length == 0) {
            this.$util.warning(`${item.name}未选择投标文件`)
            return false
          }
        }
      }
      return true
    },

    /**
     * 历史记录
     */
    goHistory(){
      this.$router.push("/history");
    },
    ...mapMutations('word', ['set_projectId_word', 'set_signName_word', 'set_checkName_word']),
    ...mapMutations("pdf", ['set_projectId_pdf', 'set_signName_pdf', 'set_checkName_pdf']),
    ...mapMutations('user', ['changeLogin', 'setServiceInfo'])
  },
  computed: {
    extList() {
      if (this.fileType == 1) {
        return ['pdf']
      } else {
        return ['docx']
      }
    },
    fileExt() {
      if (this.fileType == 1) {
        return ".pdf"
      } else {
        return ".docx"
      }
    },
    //根据单文件上传 或多文件上传  改造的投标文件列表
    tbList() {
      let temp = [];
      //多文件上传
      if (this.actionType == 2) {
        this.$_.each(this.mutil_tbList, (item) => {
          let fileList = this.$_.map(item.fileList, (file) => {
            file.unitName = item.name;
            file.unitId = item.idx;
            return file;
          });
          temp = temp.concat(fileList);
        });
        //单文件上传
      } else if (this.actionType == 1) {
        temp = this.$_.map(this.single_tbList, (item, idx) => {
          item.unitId = this.$uuid();
          item.unitName = `投标单位${idx + 1}`;
          return item;
        });
      }
      return temp;
    },
    /**
     * 是否需要上传招标
     */
    hasZb() {
      if (this.fileType == 1) {
        if (this.pdfForm.bid_sim_flag == 1) {
          return true
        } else {
          return false
        }
      } else {
        if (this.wordForm.bid_sim_flag == 1) {
          return true
        } else {
          return false
        }
      }
    },
    projectId() {
      if (this.fileType == 1) {
        let projectId = this.$uuid();
        this.set_projectId_pdf(projectId);
        return projectId;
      } else {
        let projectId = this.$uuid();
        this.set_projectId_word(projectId);
        return projectId;
      }
    },
    ...mapState('word', ['settings_word']),
    ...mapState("pdf", ['settings_pdf']),
    ...mapState('user', ['isLogin', 'serviceInfo','srcSymbol']),
  },
  filters: {
    parseTime(val) {
      return moment(Number(val)).format("YYYY年MM月DD日");
    }
  }

}
</script>

<style lang="scss" scoped>
.file_box {
  margin-top: 20px;
  min-height: 400px;
  padding: 24px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #E9EEF7 0%, rgba(255, 255, 255, 0) 100%);
  border: 2px solid #FFFFFF;
  filter: drop-shadow(0px 40px 12px rgba(77, 109, 153, 0.0012));
  border-radius: 24px;
}

.rules_box {
  margin-top: 20px;
  min-height: 200px;
  padding: 24px;
  box-sizing: border-box;

  background: linear-gradient(180deg, #E9EEF7 0%, rgba(255, 255, 255, 0) 100%);
  border: 2px solid #FFFFFF;
  filter: drop-shadow(0px 40px 12px rgba(77, 109, 153, 0.0012));
  border-radius: 24px;
}

.box_title {
  color: #1F2329;
  font-weight: 600;
  font-size: 18px;
}

.up_box {

  width: 182px;
  height: 180px;
  background: #FFFFFF;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 8px 20px 8px;
  border: 1px dashed #DEE0E3;
  border-radius: 4px;
  position: relative;

  .fileName {
    height: 80px;
    width: 160px;
    line-height: 20px;
    display: -webkit-box; /*  display: -webkit-box; 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示  */
    -webkit-box-orient: vertical; /*  -webkit-box-orient 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式  */
    -webkit-line-clamp: 2; /*  -webkit-line-clamp用来限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    font-size: 12px;
    text-align: center;
  }
}

.mutilFileBox1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 279px;
  height: 300px;
  background-color: #FFFFFF;
  border-radius: 0px;

}

.startBtn {
  width: 210px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: #3973FF;
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin: 15px auto;
  cursor: pointer;

}
</style>
